import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { CountryCode } from 'assets/countryDialCode';
import type { PayHubWidgetContractsUserCardResponse } from 'store/models';

export interface SelectedCardType extends PayHubWidgetContractsUserCardResponse {
  isNew?: boolean;
}

type CountryCodeHandler = (country: CountryCode) => void;

export interface CountryCodeState {
  countryCodeHandler?: CountryCodeHandler;
}

const initialState: CountryCodeState = {};

export const countryCodeStateSlice = createSlice({
  name: 'countryCodeState',
  initialState,
  reducers: {
    setCountryCodeHandler: (state, action: PayloadAction<CountryCodeHandler | undefined>) => ({
      ...state,
      countryCodeHandler: action.payload,
    }),
  },
});

export const countryCodeHandlerSelector = (state: { countryCodeState: CountryCodeState }) =>
  state.countryCodeState?.countryCodeHandler;

export const { setCountryCodeHandler } = countryCodeStateSlice.actions;

export default countryCodeStateSlice.reducer;
